"use strict";
exports.__esModule = true;
exports.WHY_WE_COLLECT_PERSONAL_INFO_MODAL_CONTENT = void 0;
exports.WHY_WE_COLLECT_PERSONAL_INFO_MODAL_CONTENT = {
    TITLE: 'Why we collect personal information',
    MAIN_TEXT_1: 'Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who opens an account.',
    MAIN_TEXT_2: 'This information is collected to help the government fight the funding of terrorism and money laundering activities.'
};
